(function () {
    'use strict';

    angular
        .module('app')
        .controller('NavCtrl', ['$scope', 'authService', NavCtrl]);

    function NavCtrl($scope, authService) {
        var vm = this;

        vm.auth = authService;
        vm.isCollapsed = true;

        $scope.$on('$stateChangeSuccess', function () {
            vm.isCollapsed = true;
        });

        vm.logout = function () {
            authService.logout();
        };
    };

})();